export const defaultPublicBrandProfile = {
    name: "Emanta",
    logoUrl: null,
    fontFamily: "Helvetica",
    colors: {
        primary: "#f3764a",
        text: "#262626",
        accent: "#00c4cb",
        success: "#33b436",
        background: "#ffffff",
    },
    support: {
        name: null,
        email: null,
    },
};
export function normalizePublicBrandProfile(value) {
    return {
        name: typeof value?.name === "string" && value.name.trim()
            ? value.name.trim()
            : defaultPublicBrandProfile.name,
        logoUrl: typeof value?.logoUrl === "string" && value.logoUrl.trim()
            ? value.logoUrl.trim()
            : null,
        fontFamily: typeof value?.fontFamily === "string" && value.fontFamily.trim()
            ? value.fontFamily.trim()
            : defaultPublicBrandProfile.fontFamily,
        colors: {
            primary: hexOrDefault(value?.colors?.primary, "primary"),
            text: hexOrDefault(value?.colors?.text, "text"),
            accent: hexOrDefault(value?.colors?.accent, "accent"),
            success: hexOrDefault(value?.colors?.success, "success"),
            background: hexOrDefault(value?.colors?.background, "background"),
        },
        support: {
            name: typeof value?.support?.name === "string" && value.support.name.trim()
                ? value.support.name.trim()
                : null,
            email: typeof value?.support?.email === "string" && value.support.email.trim()
                ? value.support.email.trim()
                : null,
        },
    };
}
function hexOrDefault(value, key) {
    return typeof value === "string" && /^#[0-9A-Fa-f]{6}$/.test(value)
        ? value
        : defaultPublicBrandProfile.colors[key];
}
